import Images from "../../../assets";

export const mockProducts = {
  id: "6486",
  brand: "Hario",
  title: "ΚΑΝΑΤΑ ΘΕΡΜΟΣ ΑΝΟΞΕΙΔΩΤΗ",
  chips: ["Hario", "Θερμός"],
  availabilityLabel: "Διαθέσιμο κατόπιν παραγγελίας",
  subcategory: "Θερμός",
  name: "ΚΑΝΑΤΑ ΘΕΡΜΟΣ ΑΝΟΞΕΙΔΩΤΗ",
  isBackorder: true,
  shortDescription: "Ανοξείδωτη κανάτα θερμός με κομψό στυλ, λαβή από ξύλο οξιάς και χωρητικότητα 600ml.",
  subtitleBadges: [
    { id: "availability", text: "Διαθέσιμο κατόπιν παραγγελίας", tone: "warning" },
    { id: "brand", text: "Μάρκα: Hario", tone: "muted" }
  ],
  price: {
    current: 16.20,
    old: 44.20,
    currency: "€",
    vatNote: "Τελική τιμή"
  },
  images: [
    { id: "img1", src: "/images/product-1.png", alt: "Κανάτα θερμός" },
    { id: "img2", src: "/images/product-1b.png", alt: "Κανάτα θερμός πλάγια" }
  ],
  colors: [
    { id: "blue",  name: "Μπλε",   hex: "#0066FF" },
    { id: "teal",  name: "Γαλάζιο", hex: "#33A6C6" },
    { id: "red",   name: "Κόκκινο", hex: "#B31818" },
    { id: "white", name: "Λευκό",   hex: "#FFFFFF" }
  ],
  defaultColorId: "blue",
  description: `Χρησιμοποιείται για να διατηρήσει τη θερμοκρασία του νερού ή του τσαγιού. 
Ο ανοξείδωτος χάλυβας επιτρέπει...`,
  specs: [
    { label: "Χρώμα", value: "Ασημί" },
    { label: "Χωρητικότητα", value: "600ml" },
    { label: "Βάρος", value: "800g (συσκευασία)" },
    { label: "Μέγεθος", value: "97W × 171H mm" }
  ],
  recommendations: Array.from({ length: 8 }).map((_, i) => (
      {
    id: "6486",
    name: "STAINLESS STEEL WINE CHILLER (VPB1)",
    price: 27.20,
    specialOffer: true,
    image: Images.chiller2,
        badge:'Special Offer'
  }
  ))
};
